/* Altura Home · GSAP + ScrollTrigger (cargados por CDN solo en el home).
   Un único sistema de animación para estas secciones: atributos data-ah. */

const root = document.documentElement;
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const gsap = window.gsap;
const ScrollTrigger = window.ScrollTrigger;
const motion = !reduce && !!gsap && !!ScrollTrigger;

// Sin GSAP (CDN bloqueado) o con movimiento reducido: todo visible y estático
if (!motion) root.classList.remove('ah-js');
else { root.classList.add('ah-js'); root.classList.add('ah-gsap'); }
window.__ahReady = true;

const qs = (sel, ctx = document) => ctx.querySelector(sel);
const qsa = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
const clamp = (v, a, b) => Math.min(b, Math.max(a, v));

/* ---------- Reveal: fade + subida, escalonado por data-i ---------- */
function initReveals() {
  qsa('[data-ah]').forEach((el) => {
    gsap.fromTo(el, { autoAlpha: 0, y: 20 }, {
      autoAlpha: 1, y: 0, duration: 0.8, ease: 'power3.out',
      delay: (Number(el.dataset.i) || 0) * 0.09,
      scrollTrigger: { trigger: el, start: 'top 90%', once: true },
    });
  });
  qsa('[data-ah-stagger]').forEach((parent) => {
    gsap.fromTo([...parent.children], { autoAlpha: 0, y: 20 }, {
      autoAlpha: 1, y: 0, duration: 0.8, ease: 'power3.out',
      stagger: Number(parent.dataset.ahStagger) / 1000 || 0.09,
      scrollTrigger: { trigger: parent, start: 'top 88%', once: true },
    });
  });
  // Carta: cada párrafo con fade muy lento, uno por uno
  qsa('.ah-carta__body > *').forEach((p) => {
    gsap.fromTo(p, { autoAlpha: 0, y: 14 }, {
      autoAlpha: 1, y: 0, duration: 2, ease: 'power2.out',
      scrollTrigger: { trigger: p, start: 'top 88%', once: true },
    });
  });
}

/* ---------- Contadores desde 0 ---------- */
function initCounters() {
  qsa('[data-ah-count]').forEach((el) => {
    const target = Number(el.dataset.ahCount);
    const obj = { v: 0 };
    el.textContent = '0';
    gsap.to(obj, {
      v: target, duration: 1.6, ease: 'expo.out',
      onUpdate: () => { el.textContent = String(Math.round(obj.v)); },
      scrollTrigger: { trigger: el, start: 'top 90%', once: true },
    });
  });
}

/* ---------- Parallax suave en botellas ---------- */
function initParallax() {
  const mm = gsap.matchMedia();
  const run = (amount) => {
    qsa('[data-ah-par]').forEach((el) => {
      const f = Number(el.dataset.ahPar) || 1;
      gsap.fromTo(el, { yPercent: -amount * f }, {
        yPercent: amount * f, ease: 'none',
        scrollTrigger: { trigger: el.closest('section'), start: 'top bottom', end: 'bottom top', scrub: 0.6 },
      });
    });
  };
  mm.add('(min-width: 900px)', () => run(8));
  mm.add('(max-width: 899px)', () => run(3));
}

/* ---------- Chat: mensaje por mensaje con "escribiendo" ---------- */
function initChat() {
  qsa('[data-ah-chat]').forEach((chat) => {
    const body = qs('.ah-chat__body', chat);
    const kids = [...body.children];
    let started = false;
    const measure = () => {
      if (started) return;
      kids.forEach((k) => { k.style.display = ''; });
      body.style.minHeight = '';
      body.style.minHeight = body.offsetHeight + 'px';
      kids.forEach((k) => { k.style.display = 'none'; });
    };
    measure();
    window.addEventListener('load', measure);
    let rt;
    window.addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(measure, 200); });

    const play = () => {
      started = true;
      const tl = gsap.timeline();
      kids.forEach((k) => {
        if (!k.classList.contains('ah-msg')) {
          tl.call(() => { k.style.display = ''; gsap.fromTo(k, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.4 }); });
          tl.to({}, { duration: 0.4 });
          return;
        }
        const bubble = qs('.ah-bubble', k);
        const typing = qs('.ah-typing', k);
        tl.call(() => {
          k.style.display = 'flex';
          gsap.set(bubble, { display: 'none' });
          typing.style.display = 'flex';
          gsap.fromTo(typing, { autoAlpha: 0, y: 6 }, { autoAlpha: 1, y: 0, duration: 0.25 });
        });
        tl.to({}, { duration: 0.7 });
        tl.call(() => {
          typing.style.display = 'none';
          gsap.set(bubble, { display: 'block' });
          gsap.fromTo(bubble, { autoAlpha: 0, y: 12, scale: 0.94 }, { autoAlpha: 1, y: 0, scale: 1, duration: 0.5, ease: 'back.out(1.7)' });
        });
        tl.to({}, { duration: 0.55 });
      });
      tl.call(() => { body.style.minHeight = ''; });
    };
    ScrollTrigger.create({ trigger: chat, start: 'top 62%', once: true, onEnter: play });
  });
}

/* ---------- La botella se llena (silueta oficial, scrub) ---------- */
function initFill() {
  qsa('[data-ah-fill]').forEach((sec) => {
    const liq = qs('.ah-liq-g', sec);
    const wave = qs('.ah-wave', sec);
    const labs = qsa('[data-lab]', sec);
    const bubs = qsa('.ah-fbub', sec);
    const tl = gsap.timeline({ defaults: { ease: 'none' } });
    // El líquido sube de vacío (y = 0) a lleno (y = -832)
    tl.fromTo(liq, { y: 0 }, { y: -832, duration: 1 }, 0);
    // Cada etiqueta aparece cuando el líquido alcanza su altura
    labs.forEach((l) => {
      const y = Number(l.dataset.y);
      const at = clamp((840 - y) / 832, 0, 0.94);
      const left = l.classList.contains('ah-lab--l');
      tl.fromTo(qs('.ah-lab__dot', l), { opacity: 0, scale: 0 }, { opacity: 1, scale: 1, duration: 0.04 }, at);
      tl.fromTo(qs('.ah-lab__line', l), { opacity: 1, scaleX: 0, transformOrigin: left ? '100% 50%' : '0% 50%' }, { scaleX: 1, duration: 0.06 }, at + 0.01);
      tl.fromTo(qs('.ah-lab__t', l), { opacity: 0, x: left ? 8 : -8 }, { opacity: 1, x: 0, duration: 0.06 }, at + 0.05);
    });
    ScrollTrigger.create({
      animation: tl, trigger: qs('.ah-fill__stage', sec),
      start: 'top 82%', end: 'bottom 45%', scrub: 0.6,
    });

    // Superficie ondulada y burbujas en loop, solo con la sección visible
    const loops = [gsap.to(wave, { x: -90, duration: 2.4, ease: 'none', repeat: -1, paused: true })];
    bubs.forEach((b, i) => {
      loops.push(gsap.fromTo(b, { y: 0, opacity: 0 }, {
        y: -(180 + (i % 4) * 50), opacity: 1, duration: 2.6 + (i % 3) * 0.5,
        ease: 'none', repeat: -1, delay: i * 0.35, paused: true,
        onRepeat: () => { gsap.set(b, { opacity: 0 }); },
      }));
    });
    ScrollTrigger.create({
      trigger: sec, start: 'top bottom', end: 'bottom top',
      onToggle: (self) => loops.forEach((l) => (self.isActive ? l.play() : l.pause())),
    });
  });
}

/* ---------- Small batch: contador 1 -> N en loop ---------- */
function initSmallBatch() {
  qsa('[data-ah-sb]').forEach((sec) => {
    const el = qs('[data-ah-sb-num]', sec);
    const target = Number(sec.dataset.target) || 41;
    const o = { v: 1 };
    el.textContent = '1';
    const tl = gsap.timeline({ repeat: -1, paused: true });
    tl.fromTo(o, { v: 1 }, { v: target, duration: 2.5, ease: 'power1.inOut', onUpdate: () => { el.textContent = String(Math.round(o.v)); } });
    tl.to({}, { duration: 1.5 }); // pausa en el número final
    tl.set(o, { v: 1 });
    tl.call(() => { el.textContent = '1'; });
    ScrollTrigger.create({ trigger: sec, start: 'top 90%', end: 'bottom 5%', onToggle: (self) => (self.isActive ? tl.play() : tl.pause()) });
  });
}

/* ---------- Los caballos: zoom lento ---------- */
function initHorse() {
  qsa('[data-ah-zoomwrap]').forEach((wrap) => {
    const img = qs('.ah-horse__main', wrap);
    if (!img) return;
    gsap.fromTo(img, { scale: 1.08 }, {
      scale: 1, ease: 'none',
      scrollTrigger: { trigger: wrap, start: 'top bottom', end: 'bottom 35%', scrub: 1.5 },
    });
  });
}

/* ---------- Video que se expande (documental) ---------- */
function initExpand() {
  qsa('[data-ah-expand]').forEach((sec) => {
    const wrap = qs('.ah-expand__wrap', sec);
    const card = qs('[data-ah-expand-card]', sec);
    const txt = qs('[data-ah-expand-text]', sec);
    const media = qs('.ah-expand__media > :first-child', sec);
    const mm = gsap.matchMedia();
    const build = (from) => {
      const tl = gsap.timeline({ defaults: { ease: 'none' } });
      tl.fromTo(card, { clipPath: from }, { clipPath: 'inset(0% 0% 0% 0% round 0px)', duration: 0.7 }, 0);
      if (media) tl.fromTo(media, { scale: 1.2 }, { scale: 1, duration: 0.9 }, 0);
      tl.fromTo(txt, { autoAlpha: 0, y: 30 }, { autoAlpha: 1, y: 0, duration: 0.25 }, 0.62);
      ScrollTrigger.create({ animation: tl, trigger: wrap, start: 'top top', end: 'bottom bottom', scrub: 0.5 });
    };
    mm.add('(max-width: 899px)', () => build('inset(30% 6% 30% 6% round 24px)'));
    mm.add('(min-width: 900px)', () => build('inset(24% 26% 24% 26% round 32px)'));
  });
}

/* ---------- Cómo se hace una botella: línea de tiempo con bolita ---------- */
function initTimeline() {
  const built = [];
  const build = () => {
    built.forEach((b) => { b.st && b.st.kill(); b.tl && b.tl.kill(); });
    built.length = 0;
    qsa('[data-ah-tlx]').forEach((root) => {
      const rail = qs('[data-rail]', root);
      const nodes = qsa('[data-node]', root);
      const cards = qsa('[data-card]', root);
      const ball = qs('[data-ball]', root);
      const fill = qs('[data-fill]', root);
      const dots = qs('.ah-tlx__dots', root);
      if (nodes.length < 2) return;
      const top = root.getBoundingClientRect().top;
      const ys = nodes.map((n) => n.getBoundingClientRect().top - top + n.offsetHeight / 2);
      const y0 = ys[0], y1 = ys[ys.length - 1], span = y1 - y0;
      // La línea va del primer al último nodo
      [dots, fill].forEach((el) => { el.style.top = y0 + 'px'; el.style.bottom = 'auto'; el.style.height = span + 'px'; });
      gsap.set(ball, { y: y0 - 8 });
      gsap.set(nodes, { scale: 1, backgroundColor: '#ffffff' });
      gsap.set(cards, { opacity: 0.55, y: 0, boxShadow: '0 0 0 rgba(0,0,0,0)' });

      const tl = gsap.timeline({ defaults: { ease: 'none' } });
      tl.fromTo(ball, { y: y0 - 8 }, { y: y1 - 8, duration: 1 }, 0);
      tl.fromTo(fill, { scaleY: 0 }, { scaleY: 1, duration: 1 }, 0);
      nodes.forEach((n, i) => {
        const at = clamp((ys[i] - y0) / span, 0, 0.985);
        tl.to(n, { backgroundColor: '#5f6b57', duration: 0.02 }, at);
        tl.fromTo(n, { scale: 1 }, { keyframes: { scale: [1, 1.6, 1], easeEach: 'power2.out' }, duration: 0.06 }, at);
        tl.to(cards[i], { opacity: 1, y: -4, boxShadow: '0 12px 28px rgba(17,17,17,0.10)', duration: 0.05 }, at);
      });
      const st = ScrollTrigger.create({ animation: tl, trigger: root, start: 'top 72%', end: 'bottom 58%', scrub: 0.6 });
      built.push({ st, tl });
    });
  };
  build();
  let rt;
  window.addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(() => { build(); ScrollTrigger.refresh(); }, 250); });
  window.addEventListener('load', () => setTimeout(build, 100));
}

/* ---------- La fórmula: máquina de escribir ---------- */
function initFormula() {
  qsa('[data-ah-fm]').forEach((sec) => {
    const paper = qs('[data-ah-fm-paper]', sec);
    const rows = qsa('.ah-fm__row', paper);
    const stamp = qs('[data-ah-stamp]', paper);

    // Separar cada término en palabras y letras (el texto completo ya está en el aria-label)
    const letters = [];
    qsa('[data-type]', paper).forEach((txt) => {
      const text = txt.textContent;
      txt.textContent = '';
      const words = text.split(' ');
      words.forEach((w, wi) => {
        const ws = document.createElement('span');
        ws.className = 'ah-w';
        [...w].forEach((c) => {
          const ch = document.createElement('span');
          ch.className = 'ah-ch';
          ch.textContent = c;
          ws.appendChild(ch);
        });
        txt.appendChild(ws);
        if (wi < words.length - 1) txt.appendChild(document.createTextNode(' '));
      });
    });

    let cursor = null;
    const setCursor = (el) => { if (cursor) cursor.classList.remove('cur'); cursor = el; if (el) el.classList.add('cur'); };
    const rnd = (a, b) => a + Math.random() * (b - a);

    const build = () => {
      const tl = gsap.timeline({ paused: true });
      let t = 0.3;
      rows.forEach((row) => {
        const pens = qsa('.ah-fm__op .ah-pen', row);
        if (pens.length) {
          tl.fromTo(pens, { strokeDashoffset: 1 }, { strokeDashoffset: 0, duration: 0.28, ease: 'power1.out', stagger: 0.16 }, t);
          t += 0.28 + 0.16 * (pens.length - 1) + 0.08;
        }
        const chs = qsa('.ah-ch', row);
        chs.forEach((ch) => {
          tl.set(ch, { opacity: 1, rotation: rnd(-1.5, 1.5) }, t);
          tl.call(setCursor, [ch], t);
          t += rnd(0.035, 0.09);
        });
        // tachado a mano o subrayado después de escribir
        const marks = qsa('.ah-fm__strike .ah-pen, .ah-fm__under .ah-pen', row);
        if (marks.length) {
          t += 0.12;
          tl.fromTo(marks, { strokeDashoffset: 1 }, { strokeDashoffset: 0, duration: 0.45, ease: 'power1.inOut' }, t);
          t += 0.45;
        }
        t += 0.12;
      });
      tl.call(() => setCursor(null), null, t);
      // Sello de goma: cae con rebote corto
      tl.fromTo(stamp, { opacity: 0, scale: 1.9, rotation: -22 }, { opacity: 0.85, scale: 1, rotation: -8, duration: 0.38, ease: 'back.out(2.4)' }, t + 0.25);
      tl.fromTo(paper, { y: 0 }, { keyframes: { y: [0, 3, 0] }, duration: 0.16, ease: 'sine.inOut' }, t + 0.5);
      return tl;
    };

    const reset = () => {
      setCursor(null);
      gsap.set(qsa('.ah-ch', paper), { opacity: 0, rotation: 0 });
      gsap.set(qsa('.ah-pen', paper), { strokeDashoffset: 1 });
      gsap.set(stamp, { opacity: 0 });
    };
    reset();
    const tl = build();
    // Se repite cada vez que la sección vuelve a entrar al viewport
    ScrollTrigger.create({
      trigger: paper, start: 'top 72%', end: 'bottom 12%',
      onEnter: () => { reset(); tl.restart(); },
      onEnterBack: () => { reset(); tl.restart(); },
      onLeave: () => { tl.pause(); reset(); },
      onLeaveBack: () => { tl.pause(); reset(); },
    });
  });
}

/* ---------- El proceso: documental con scroll fijo ---------- */
function initDoc() {
  const sec = qs('[data-ah-doc]');
  if (!sec) return;
  const stage = qs('.ah-doc__stage', sec);
  const wrap = qs('.ah-doc__stage-wrap', sec);
  const svg = qs('.ah-doc__svg', sec);
  const chs = qsa('.ah-doc__ch', svg);
  const N = Math.min(chs.length, qsa('.ah-doc__nar', sec).length) || chs.length;
  const g = (i) => chs[i];
  const D = (i, sel) => qsa(sel || '.ah-d', g(i));
  const sel = (i, s) => qs(s, g(i));

  /* Contadores de cada capítulo (config desde el schema, en data-*) */
  const cnts = qsa('.ah-doc__cnt', sec);

  const tl = gsap.timeline({ defaults: { ease: 'none' } });
  const draw = (targets, t, dur, stagger = 0) => {
    if (!targets || (targets.length === 0)) return;
    tl.fromTo(targets, { strokeDashoffset: 1 }, { strokeDashoffset: 0, duration: dur, stagger }, t);
  };
  const undraw = (targets, t, dur, stagger = 0) => tl.to(targets, { strokeDashoffset: 1, duration: dur, stagger }, t);
  const fade = (target, t, dur, to) => tl.to(target, { opacity: to, duration: dur }, t);
  const counter = (i, t, dur) => {
    const el = cnts.find((c) => Number(c.dataset.ci) === i);
    if (!el || el.dataset.to === undefined || el.dataset.to === '') return;
    const num = qs('[data-num]', el);
    const from = Number(el.dataset.from || 0), to = Number(el.dataset.to);
    const pre = el.dataset.prefix || '', suf = el.dataset.suffix || '';
    const o = { v: from };
    num.textContent = pre + from + suf;
    tl.fromTo(o, { v: from }, { v: to, duration: dur, onUpdate: () => { num.textContent = pre + Math.round(o.v) + suf; } }, t);
  };

  /* Pivotes para elementos SVG que giran o se desplazan */
  const leaves = qsa('.ah-leaf', g(0));

  /* 01 · Cosecha: agave, coa y piña */
  if (N > 0) {
    draw(D(0, '.ah-ground'), 0, 0.1);
    draw(leaves, 0.05, 0.2, 0.03);
    draw(D(0, '.ah-coa'), 0.42, 0.14, 0.02);
    const coa = sel(0, '.ah-coa-g');
    tl.to(coa, { rotation: -9, svgOrigin: '335 40', duration: 0.04 }, 0.58)
      .to(coa, { rotation: 2, svgOrigin: '335 40', duration: 0.04 }, 0.62)
      .to(coa, { rotation: -9, svgOrigin: '335 40', duration: 0.04 }, 0.66)
      .to(coa, { rotation: 2, svgOrigin: '335 40', duration: 0.04 }, 0.70)
      .to(coa, { rotation: -9, svgOrigin: '335 40', duration: 0.04 }, 0.74);
    undraw([...leaves].reverse(), 0.6, 0.1, 0.022);
    draw(D(0, '.ah-pina'), 0.74, 0.16, 0.02);
    fade(coa, 0.82, 0.08, 0);
  }

  /* 02 · Cocción: horno de mampostería */
  if (N > 1) {
    draw(D(1, '.ah-ground, .ah-kiln'), 1.0, 0.3, 0.04);
    draw(D(1, '.ah-pina2'), 1.34, 0.1);
    tl.to(sel(1, '.ah-pina2-g'), { x: 122, duration: 0.24 }, 1.46);
    fade(sel(1, '.ah-flames'), 1.66, 0.08, 1);
    fade(sel(1, '.ah-vapor'), 1.7, 0.1, 1);
    counter(1, 1.38, 0.56);
  }

  /* 03 · Fermentación: tina con burbujas */
  if (N > 2) {
    draw(D(2, '.ah-ground, .ah-vat'), 2.0, 0.34, 0.04);
    draw(D(2, '.ah-surface'), 2.32, 0.1);
    fade(sel(2, '.ah-bubbles'), 2.45, 0.1, 1);
    counter(2, 2.1, 0.8);
  }

  /* 04 · Destilación: cabeza, corazón y cola */
  if (N > 3) {
    draw(D(3, '.ah-ground, .ah-still'), 3.0, 0.32, 0.03);
    tl.fromTo(qsa('.ah-vtext', g(3)), { opacity: 0 }, { opacity: 1, duration: 0.1 }, 3.26);
    const vials = sel(3, '.ah-vials');
    const [vh, vc, vt] = qsa('.ah-vial', g(3));
    tl.set(vials, { x: 53 }, 3.0);
    fade(sel(3, '.ah-drops'), 3.3, 0.06, 1);
    tl.fromTo(qs('.ah-liq', vh), { scaleY: 0, transformOrigin: '50% 100%' }, { scaleY: 0.4, duration: 0.18 }, 3.3);
    tl.to(vials, { x: 0, duration: 0.08 }, 3.5);
    tl.fromTo(qs('.ah-liq', vc), { scaleY: 0, transformOrigin: '50% 100%' }, { scaleY: 0.85, duration: 0.2 }, 3.52);
    tl.to(vials, { x: -53, duration: 0.08 }, 3.7);
    tl.fromTo(qs('.ah-liq', vt), { scaleY: 0, transformOrigin: '50% 100%' }, { scaleY: 0.3, duration: 0.14 }, 3.72);
    tl.to(vials, { x: 0, duration: 0.1 }, 3.88);
    draw(D(3, '.ah-strike'), 3.84, 0.1, 0.03);
    fade([vh, vt], 3.88, 0.08, 0.25);
    tl.to(qs('.ah-vial-line', vc), { stroke: '#5f6b57', duration: 0.06 }, 3.9);
    fade(sel(3, '.ah-drops'), 3.9, 0.04, 0);
    counter(3, 3.1, 0.8);
  }

  /* 05 · Reposo: barrica y líquido ámbar */
  if (N > 4) {
    draw(D(4, '.ah-ground, .ah-barrel'), 4.0, 0.4, 0.03);
    draw(D(4, '.ah-glass'), 4.4, 0.1);
    tl.fromTo(sel(4, '.ah-amber'), { opacity: 0 }, { opacity: 0.85, duration: 0.5 }, 4.45);
    counter(4, 4.1, 0.85);
  }

  /* Transiciones: el dibujo anterior se desvanece y el nuevo se traza */
  for (let i = 0; i < N - 1; i++) {
    tl.to(g(i), { opacity: 0, duration: 0.07 }, i + 0.92);
    tl.set(g(i + 1), { opacity: 1 }, i + 1);
  }
  tl.to({}, { duration: N - tl.duration() > 0 ? N - tl.duration() : 0 }, tl.duration());

  /* Animaciones en loop (llamas, vapor, burbujas, gotas), solo con la sección visible */
  const loops = [];
  const flames = qsa('.ah-flame', g(1));
  if (flames.length) loops.push(gsap.to(flames, { scaleY: 1.25, scaleX: 0.9, transformOrigin: '50% 100%', duration: 0.45, repeat: -1, yoyo: true, ease: 'sine.inOut', stagger: 0.12, paused: true }));
  const vapors = qsa('.ah-vap', g(1));
  if (vapors.length) loops.push(gsap.fromTo(vapors, { y: 0, opacity: 0.9 }, { y: -26, opacity: 0, duration: 1.8, repeat: -1, ease: 'sine.out', stagger: 0.55, paused: true }));
  qsa('.ah-bub', g(2)).forEach((b, i) => {
    const t = gsap.timeline({ repeat: -1, paused: true, delay: i * 0.3 });
    t.fromTo(b, { y: 0, opacity: 0 }, { y: -(70 + (i % 3) * 14), opacity: 1, duration: 1.6, ease: 'none' }).to(b, { opacity: 0, duration: 0.4 }, '-=0.5');
    loops.push(t);
  });
  const drops = qsa('.ah-drop', g(3));
  if (drops.length) loops.push(gsap.fromTo(drops, { y: 0, opacity: 1 }, { y: 44, opacity: 0.2, duration: 0.7, repeat: -1, ease: 'power1.in', stagger: 0.35, paused: true }));

  /* HUD: capítulo activo, timecode, línea de tiempo */
  const chapNo = qs('.ah-doc__chapno', sec);
  const tc = qs('.ah-doc__tc b', sec);
  const fill = qs('.ah-doc__fill', sec);
  const marks = qsa('.ah-doc__mark', sec);
  const titles = qsa('.ah-doc__ct', sec);
  const nars = qsa('.ah-doc__nar', sec);
  const totalSeconds = Number(sec.dataset.seconds) || 300;
  const pad = (n, l = 2) => String(n).padStart(l, '0');
  let current = -1;

  const setChapter = (i) => {
    if (i === current) return;
    current = i;
    chapNo.textContent = `CAPÍTULO ${pad(i + 1)} / ${pad(N)}`;
    titles.forEach((el) => el.classList.toggle('is-on', Number(el.dataset.ci) === i));
    nars.forEach((el) => el.classList.toggle('is-on', Number(el.dataset.ci) === i));
    cnts.forEach((el) => el.classList.toggle('is-on', Number(el.dataset.ci) === i));
    marks.forEach((m, k) => { m.classList.toggle('is-on', k === i); m.classList.toggle('is-done', k < i); });
  };
  setChapter(0);

  ScrollTrigger.create({
    animation: tl, trigger: wrap, start: 'top top', end: 'bottom bottom', scrub: 0.5,
    onUpdate: (self) => {
      const p = self.progress;
      setChapter(clamp(Math.floor(p * N), 0, N - 1));
      const s = p * totalSeconds;
      tc.textContent = `${pad(Math.floor(s / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(Math.floor(s % 60))}:${pad(Math.floor((s % 1) * 25))}`;
      fill.style.transform = `scaleX(${p.toFixed(4)})`;
    },
    onToggle: (self) => loops.forEach((l) => (self.isActive ? l.play() : l.pause())),
  });
}

/* ---------- Videos: solo reproducen cuando son visibles ---------- */
function initVideos() {
  const vids = qsa('.ah video');
  if (!vids.length || !('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      const v = e.target;
      v.muted = true;
      v.playsInline = true;
      if (e.isIntersecting) { const p = v.play(); if (p && p.catch) p.catch(() => {}); }
      else v.pause();
    });
  }, { threshold: 0.25 });
  vids.forEach((v) => io.observe(v));
}

/* ---------- ScrollTrigger.refresh() cuando terminan de cargar imágenes y videos ---------- */
function refreshOnMedia() {
  if (!motion) return;
  let t;
  const refresh = () => { clearTimeout(t); t = setTimeout(() => ScrollTrigger.refresh(), 200); };
  qsa('.ah img').forEach((img) => { if (!img.complete) img.addEventListener('load', refresh, { once: true }); });
  qsa('.ah video').forEach((v) => v.addEventListener('loadedmetadata', refresh, { once: true }));
  window.addEventListener('load', refresh);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
}

/* ---------- Carruseles: puntos y teclado ---------- */
function initCarousels() {
  qsa('[data-ah-carousel]').forEach((car) => {
    const slides = qsa('[data-slide]', car);
    const dotsWrap = car.parentNode.querySelector('[data-ah-dots]');
    const center = (s) => s.offsetLeft - (car.clientWidth - s.clientWidth) / 2;
    let dots = [];
    const setActive = () => {
      const mid = car.scrollLeft + car.clientWidth / 2;
      let best = 0, bestD = Infinity;
      slides.forEach((s, i) => {
        const d = Math.abs(s.offsetLeft + s.clientWidth / 2 - mid);
        if (d < bestD) { bestD = d; best = i; }
      });
      dots.forEach((d, i) => d.setAttribute('aria-current', i === best ? 'true' : 'false'));
    };
    if (dotsWrap && slides.length > 1) {
      dots = slides.map((s, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', `Ir a ${i + 1} de ${slides.length}`);
        b.addEventListener('click', () => car.scrollTo({ left: center(s), behavior: reduce ? 'auto' : 'smooth' }));
        dotsWrap.appendChild(b);
        return b;
      });
      car.addEventListener('scroll', () => requestAnimationFrame(setActive), { passive: true });
      setActive();
    }
    const feat = qs('[data-feat]', car);
    if (feat && !window.matchMedia('(min-width: 900px)').matches) {
      car.scrollLeft = center(feat);
      setActive();
    }
  });
}

/* ---------- Barra de compra fija (mobile) ---------- */
function initSticky() {
  const bar = qs('[data-ah-sticky]');
  const star = qs('.ah-star');
  if (!bar || !star) return;
  const end = qs('[data-ah-end]');
  const hideZones = qsa('[data-ah-hidebar]');
  let ticking = false;
  const update = () => {
    ticking = false;
    const past = star.getBoundingClientRect().bottom < 0;
    const atEnd = end ? end.getBoundingClientRect().top < window.innerHeight * 0.6 : false;
    // Se oculta mientras el documental ocupa la pantalla, para no tapar su pie
    const inDoc = hideZones.some((z) => {
      const r = z.getBoundingClientRect();
      return r.top < window.innerHeight * 0.5 && r.bottom > window.innerHeight * 0.5;
    });
    const show = past && !atEnd && !inDoc;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    if ('inert' in bar) bar.inert = !show;
  };
  window.addEventListener('scroll', () => {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
  window.addEventListener('resize', update);
  update();
}

/* A partir de 990px el tema scrollea dentro de .page-wrapper (no en la ventana).
   ScrollTrigger tiene que escuchar ese contenedor o nada se anima en desktop. */
const wide = window.matchMedia('(min-width: 990px)');
const pageWrapper = qs('.page-wrapper');
const scroller = wide.matches && pageWrapper ? pageWrapper : window;
if (pageWrapper) {
  const header = qs('.ad-header');
  pageWrapper.addEventListener('scroll', () => {
    window.dispatchEvent(new Event('scroll'));
    // El header del tema decide su estado con window.scrollY, que en desktop siempre es 0.
    // Aquí lo volvemos sólido al pasar el hero para que el menú se lea sobre fondo claro.
    if (header && wide.matches) header.classList.toggle('ad-header--solid', pageWrapper.scrollTop > 60);
  }, { passive: true });
}
let lastWide = wide.matches;
let rzt;
window.addEventListener('resize', () => {
  clearTimeout(rzt);
  rzt = setTimeout(() => { if (wide.matches !== lastWide) location.reload(); }, 400);
});

if (motion) {
  gsap.registerPlugin(ScrollTrigger);
  ScrollTrigger.defaults({ scroller });
  initReveals();
  initCounters();
  initParallax();
  initChat();
  initFill();
  initDoc();
  initSmallBatch();
  initHorse();
  initExpand();
  initTimeline();
  initFormula();
}
initVideos();
refreshOnMedia();
initCarousels();
initSticky();
